// @flow
import { connect } from 'react-redux';

import { selectCartUUID } from '@gandi/cart';

import type { FullState, MapDispatchToProps } from '../../../../../types';
import { saveDraftContact } from '../../../modules/actions';

import Presenter, { type DispatchProps, type StateProps } from './Presenter';

const mapStateToProps = (state: FullState): StateProps => ({
  cartId: selectCartUUID(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps> = {
  saveDraftContact,
};

// $FlowFixMe[signature-verification-failure]
// $FlowFixMe[underconstrained-implicit-instantiation]
const SelectFromContactBook = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Presenter);

SelectFromContactBook.displayName = 'SelectFromContactBook';

export default SelectFromContactBook;
